module.exports = __webpack_public_path__ + "static/media/name.c7a5c5b3.webp";